module.exports = __webpack_public_path__ + "media/images/danger-1b94d5c3d6137ad09ad7e99e40ac9ca5.gif";